module.exports = __webpack_public_path__ + "img/Image3.88709734.png";